// Единый источник данных для трейдера Echo Capital
// Все экраны (ProfileScreen, CopytradingSection, TraderDetailsScreen) используют этот файл
// При необходимости обновить данные — менять только здесь

export const ECHO_CAPITAL = {
  name: 'Echo Capital',
  avatar: 'https://i.ibb.co/tT2Lg9vB/avatar.jpg',
  followers: 145,
  maxFollowers: 200,
  drawdown: 5.2,
  tradingDays: 543,
  stabilityIndex: 4.7,

  // PnL
  pnl7d: 648372,
  pnl30d: 2781946,
  pnl90d: 8347615,

  // AUM
  aum: 13964283,

  // ROI
  roi: 19.93,
  roi30d: 37.83,
  roi90d: 59.77
}

// Базовые значения для периодической анимации на ProfileScreen
// (значения слегка колеблются ±3.5% от базовых)
export const BASE_TRADER_STATS = {
  pnl7d: ECHO_CAPITAL.pnl7d,
  pnl30d: ECHO_CAPITAL.pnl30d,
  pnl90d: ECHO_CAPITAL.pnl90d,
  aum: ECHO_CAPITAL.aum,
  roi: ECHO_CAPITAL.roi,
  roi90d: ECHO_CAPITAL.roi90d
}

// Ключ для localStorage (кеш анимированных значений)
export const TRADER_STATS_STORAGE_KEY = 'trader_stats_values'
